import ReadOnlyView from './ReadOnlyView'

export default ReadOnlyView
